var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mdt-section-toggle clickable",class:{ active: _vm.value }},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('i',{staticClass:"fas",class:_vm.value ? 'fa-angle-up' : 'fa-angle-down'})])
}
var staticRenderFns = []

export { render, staticRenderFns }